module.exports = __webpack_public_path__ + "static/media/gitlab.4a3b74d3.jpg";